module.exports = __webpack_public_path__ + "262970974c843445bf353cd26fe3efa1.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/MainMenu/MenuSnacksDessert.png
// module id = 411
// module chunks = 0